// SVG artwork copied from the user-supplied opening reference.

export function BirthHeart() {
  return (<svg className="heart-svg" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
      <path d="M50 88 C 22 64 8 46 8 28 C 8 16 18 8 28 8 C 38 8 46 14 50 22 C 54 14 62 8 72 8 C 82 8 92 16 92 28 C 92 46 78 64 50 88 Z" fill="#e55454"/>
      <path d="M50 88 C 22 64 8 46 8 28 C 8 16 18 8 28 8 C 38 8 46 14 50 22 C 54 14 62 8 72 8 C 82 8 92 16 92 28 C 92 46 78 64 50 88 Z" fill="url(#heartShine)"/>
      <defs>
        <radialGradient id="heartShine" cx="35%" cy="30%" r="60%">
          <stop offset="0%" stopColor="#fff" stopOpacity="0.55"/>
          <stop offset="60%" stopColor="#fff" stopOpacity="0"/>
        </radialGradient>
      </defs>
    </svg>)
}

export function BirthBaby() {
  return (<svg className="baby-svg" viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <radialGradient id="babyGlow" cx="50%" cy="50%" r="50%">
          <stop offset="0%" stopColor="#fff" stopOpacity="0.5"/>
          <stop offset="60%" stopColor="#fff" stopOpacity="0.1"/>
          <stop offset="100%" stopColor="#fff" stopOpacity="0"/>
        </radialGradient>
      </defs>
      <g className="birth-glow">
        <circle cx="100" cy="100" r="80" fill="url(#babyGlow)"/>
      </g>
      <g className="birth-orbit">
        <path d="M 30 100 A 70 70 0 0 1 170 100" fill="none" stroke="#fff" strokeOpacity="0.35" strokeWidth="1.5" strokeLinecap="round"/>
        <path d="M 170 100 A 70 70 0 0 1 30 100" fill="none" stroke="#fff" strokeOpacity="0.15" strokeWidth="1" strokeLinecap="round" strokeDasharray="3 4"/>
      </g>
      <ellipse cx="100" cy="150" rx="42" ry="34" fill="#e8eef3"/>
      <ellipse cx="100" cy="150" rx="42" ry="34" fill="none" stroke="#a8b4be" strokeWidth="0.8"/>
      <path d="M 70 145 Q 100 168 130 145" fill="none" stroke="#c0cbd5" strokeWidth="1" opacity="0.6"/>
      <circle cx="100" cy="85" r="38" fill="#fde2d2"/>
      <path d="M 66 75 Q 72 50 100 50 Q 128 50 134 75 Q 132 68 122 64 Q 110 60 100 60 Q 90 60 78 64 Q 68 68 66 75 Z" fill="#3d2817"/>
      <path d="M 76 88 Q 81 92 86 88" fill="none" stroke="#3d2817" strokeWidth="1.8" strokeLinecap="round"/>
      <path d="M 114 88 Q 119 92 124 88" fill="none" stroke="#3d2817" strokeWidth="1.8" strokeLinecap="round"/>
      <ellipse cx="74" cy="100" rx="6" ry="3" fill="#f5a8a8" opacity="0.65"/>
      <ellipse cx="126" cy="100" rx="6" ry="3" fill="#f5a8a8" opacity="0.65"/>
      <path d="M 95 105 Q 100 108 105 105" fill="none" stroke="#c97777" strokeWidth="1.5" strokeLinecap="round"/>
      <ellipse cx="100" cy="118" rx="9" ry="13" fill="#fde2d2" transform="rotate(-12 100 118)"/>
      <ellipse cx="102" cy="112" rx="3" ry="4" fill="#fde2d2"/>
      <ellipse cx="98" cy="113" rx="2" ry="3" fill="#fde2d2"/>
      <ellipse cx="105" cy="113" rx="2" ry="3" fill="#fde2d2"/>
    </svg>)
}

export function BirthPortrait() {
  return (<svg className="baby-svg" viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
          <ellipse cx="100" cy="150" rx="42" ry="34" fill="#e8eef3"/>
          <ellipse cx="100" cy="150" rx="42" ry="34" fill="none" stroke="#a8b4be" strokeWidth="0.8"/>
          <path d="M 70 145 Q 100 168 130 145" fill="none" stroke="#c0cbd5" strokeWidth="1" opacity="0.6"/>
          <circle cx="100" cy="85" r="38" fill="#fde2d2"/>
          <path d="M 66 75 Q 72 50 100 50 Q 128 50 134 75 Q 132 68 122 64 Q 110 60 100 60 Q 90 60 78 64 Q 68 68 66 75 Z" fill="#3d2817"/>
          <path d="M 76 88 Q 81 92 86 88" fill="none" stroke="#3d2817" strokeWidth="1.8" strokeLinecap="round"/>
          <path d="M 114 88 Q 119 92 124 88" fill="none" stroke="#3d2817" strokeWidth="1.8" strokeLinecap="round"/>
          <ellipse cx="74" cy="100" rx="6" ry="3" fill="#f5a8a8" opacity="0.65"/>
          <ellipse cx="126" cy="100" rx="6" ry="3" fill="#f5a8a8" opacity="0.65"/>
          <path d="M 95 105 Q 100 108 105 105" fill="none" stroke="#c97777" strokeWidth="1.5" strokeLinecap="round"/>
          <ellipse cx="100" cy="118" rx="9" ry="13" fill="#fde2d2" transform="rotate(-12 100 118)"/>
          <ellipse cx="102" cy="112" rx="3" ry="4" fill="#fde2d2"/>
          <ellipse cx="98" cy="113" rx="2" ry="3" fill="#fde2d2"/>
          <ellipse cx="105" cy="113" rx="2" ry="3" fill="#fde2d2"/>
        </svg>)
}
